import React from 'react';
const SvgVstxThumbnail = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg viewBox="0 0 96 96" width="1em" height="1em" {...props}>
      <path fill="#FFF" d="M82 12V6H24v78h6v6h58V12z" />
      <path fill="#C8C8C8" d="M52 50v10H42V50h10m2-2H40v14h14V48z" />
      <path fill="#3955A3" d="M82 6H24v12h58v-8l6 6v-4z" />
      <path fill="#949494" d="M86 14v74H32v-4h50V18h-2v64H26V18h-2v66h6v6h58V16z" />
      <path
        fill="#C8C8C8"
        d="M67 64c2.757 0 5 2.243 5 5s-2.243 5-5 5-5-2.243-5-5 2.243-5 5-5m0-2a7 7 0 100 14 7 7 0 000-14zM61 32c2.757 0 5 2.243 5 5s-2.243 5-5 5-5-2.243-5-5 2.243-5 5-5m0-2a7 7 0 100 14 7 7 0 000-14zM68 54H54v2h14v-2z"
      />
      <path
        fill="#C8C8C8"
        d="M68 56h-2v8h2v-8zM62 42h-2v14h2V42zM33 24a1 1 0 10-.001 1.999A1 1 0 0033 24zM39 24a1 1 0 10-.001 1.999A1 1 0 0039 24zM45 24a1 1 0 10-.001 1.999A1 1 0 0045 24zM51 24a1 1 0 10-.001 1.999A1 1 0 0051 24zM57 24a1 1 0 10-.001 1.999A1 1 0 0057 24zM73 34a1 1 0 10-.001 1.999A1 1 0 0073 34zM73 40a1 1 0 10-.001 1.999A1 1 0 0073 40zM73 46a1 1 0 10-.001 1.999A1 1 0 0073 46zM73 52a1 1 0 10-.001 1.999A1 1 0 0073 52zM73 58a1 1 0 10-.001 1.999A1 1 0 0073 58zM57 74a1 1 0 10-.001 1.999A1 1 0 0057 74zM51 74a1 1 0 10-.001 1.999A1 1 0 0051 74z"
      />
      <path fill="#3955A3" d="M8 34l40-6v52L8 74z" />
      <path
        fill="#FFF"
        d="M39 43l-8.062 23h-5.974L17 43h5.68l4.88 16.007c.26.866.418 1.631.473 2.294h.097c.076-.717.245-1.503.506-2.358L33.484 43H39z"
      />
      <linearGradient
        id="vstx-thumbnail_svg__a"
        gradientUnits="userSpaceOnUse"
        x1={35.508}
        y1={85.837}
        x2={36.355}
        y2={77.86}
      >
        <stop offset={0} stopColor="#828282" stopOpacity={0} />
        <stop offset={0.17} stopColor="#7e7e7e" stopOpacity={0.034} />
        <stop offset={0.346} stopColor="#717171" stopOpacity={0.069} />
        <stop offset={0.525} stopColor="#5d5d5d" stopOpacity={0.105} />
        <stop offset={0.706} stopColor="#404040" stopOpacity={0.141} />
        <stop offset={0.886} stopColor="#1b1b1b" stopOpacity={0.178} />
        <stop offset={0.997} stopOpacity={0.2} />
      </linearGradient>
      <path fill="url(#vstx-thumbnail_svg__a)" d="M48 86H24v-9.6L48 80z" />
      <linearGradient
        id="vstx-thumbnail_svg__b"
        gradientUnits="userSpaceOnUse"
        x1={25.998}
        y1={16.439}
        x2={80.002}
        y2={85.561}
      >
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.226} stopColor="#fcfcfc" stopOpacity={0.023} />
        <stop offset={0.363} stopColor="#f4f4f4" stopOpacity={0.036} />
        <stop offset={0.475} stopColor="#e6e6e6" stopOpacity={0.048} />
        <stop offset={0.574} stopColor="#d1d1d1" stopOpacity={0.057} />
        <stop offset={0.665} stopColor="#b7b7b7" stopOpacity={0.067} />
        <stop offset={0.75} stopColor="#979797" stopOpacity={0.075} />
        <stop offset={0.83} stopColor="#707070" stopOpacity={0.083} />
        <stop offset={0.906} stopColor="#444" stopOpacity={0.091} />
        <stop offset={0.976} stopColor="#121212" stopOpacity={0.098} />
        <stop offset={1} stopOpacity={0.1} />
      </linearGradient>
      <path fill="url(#vstx-thumbnail_svg__b)" d="M24 18h58v66H24z" />
      <linearGradient
        id="vstx-thumbnail_svg__c"
        gradientUnits="userSpaceOnUse"
        x1={46.856}
        y1={37.457}
        x2={87.943}
        y2={90.045}
      >
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.226} stopColor="#fcfcfc" stopOpacity={0.023} />
        <stop offset={0.363} stopColor="#f4f4f4" stopOpacity={0.036} />
        <stop offset={0.475} stopColor="#e6e6e6" stopOpacity={0.048} />
        <stop offset={0.574} stopColor="#d1d1d1" stopOpacity={0.057} />
        <stop offset={0.665} stopColor="#b7b7b7" stopOpacity={0.067} />
        <stop offset={0.75} stopColor="#979797" stopOpacity={0.075} />
        <stop offset={0.83} stopColor="#707070" stopOpacity={0.083} />
        <stop offset={0.906} stopColor="#444" stopOpacity={0.091} />
        <stop offset={0.976} stopColor="#121212" stopOpacity={0.098} />
        <stop offset={1} stopOpacity={0.1} />
      </linearGradient>
      <path fill="url(#vstx-thumbnail_svg__c)" d="M82 10v74H30v6h58V16z" />
      <linearGradient id="vstx-thumbnail_svg__d" gradientUnits="userSpaceOnUse" x1={56} y1={89.813} x2={56} y2={84.175}>
        <stop offset={0} stopColor="#828282" stopOpacity={0} />
        <stop offset={0.281} stopColor="#7f7f7f" stopOpacity={0.028} />
        <stop offset={0.45} stopColor="#777" stopOpacity={0.045} />
        <stop offset={0.59} stopColor="#696969" stopOpacity={0.059} />
        <stop offset={0.713} stopColor="#545454" stopOpacity={0.071} />
        <stop offset={0.826} stopColor="#3a3a3a" stopOpacity={0.083} />
        <stop offset={0.929} stopColor="#1a1a1a" stopOpacity={0.093} />
        <stop offset={1} stopOpacity={0.1} />
      </linearGradient>
      <path fill="url(#vstx-thumbnail_svg__d)" d="M30 84h52v6H30z" />
      <linearGradient
        id="vstx-thumbnail_svg__e"
        gradientUnits="userSpaceOnUse"
        x1={55.678}
        y1={17.154}
        x2={56.331}
        y2={4.68}
      >
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.854} stopColor="#fff" stopOpacity={0.213} />
        <stop offset={1} stopColor="#fff" stopOpacity={0.25} />
      </linearGradient>
      <path fill="url(#vstx-thumbnail_svg__e)" d="M82 6H24v12h58v-8l6 6v-4z" />
      <linearGradient id="vstx-thumbnail_svg__f" gradientUnits="userSpaceOnUse" x1={28} y1={78.375} x2={28} y2={29.517}>
        <stop offset={0} stopColor="#fff" stopOpacity={0} />
        <stop offset={0.859} stopColor="#fff" stopOpacity={0.155} />
        <stop offset={1} stopColor="#fff" stopOpacity={0.18} />
      </linearGradient>
      <path fill="url(#vstx-thumbnail_svg__f)" d="M48 28L8 34v40l40 6z" />
    </svg>
  );
});
export default SvgVstxThumbnail;
SvgVstxThumbnail.iconName = 'vstx-thumbnail';
SvgVstxThumbnail.displayName = 'SvgVstxThumbnail';
